<template lang="html">
  <item-editor-dialog
    :id="selectedItemId"
    ref="editForm"
    v-model="selectedPanel"
    :show="showItem"
    :clone-id="cloneId"
    :title="pageTitle"
    :on-close="doClose"
    :context-menu="defaultContextMenu"
    :lock-timer="lockTimerSettings"
    :loading="isDataLoading"
    :errors="errors"
    :edit-panel-id="editPanel"
    :audit-panel-id="auditPanel"
    :audit="auditHistorySettings"
    :buttons="pageBarButtons"
  >
    <!-- BUILD EVENT DIALOG -->
    <v-dialog
      v-model="showEventCloneDialog"
      :max-width="600"
      scrollable
    >
      <v-card v-if="baseEvent">
        <v-card-title class="pb-2">
          <div class="headline">
            Clone Event
          </div>
        </v-card-title>
        <v-card-title class="pt-0">
          <div class="subheading">
            {{ baseEvent.name }} - {{ $ftPrettyTime(baseEvent.startTime) }} to {{ $ftPrettyTime(baseEvent.endTime) }}
          </div>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-tabs
            v-model="recurConf.selectedRecurTabIndex"
            :light="!$ftAppIsDark"
            :dark="$ftAppIsDark"
            :color="$ftStyle.pageBarTabs"
            :disabled="isFormDisabled"
            show-arrows
          >
            <v-tabs-slider :color="$ftStyle.pageBarTabsSlider" />
            <v-tab
              v-for="(tab, i) in recurTabs"
              :key="i"
            >
              {{ tab.text }}
            </v-tab>

            <v-tab-item :key="0">
              <v-card
                flat
                class="pt-3"
              >
                <!--
                  <v-autocomplete
                    label="Daily Mode"
                    v-model="recurConf.dailyMode"
                    :items="recurDailyModes"></v-autocomplete>
                  -->
                <v-card-text
                  v-if="recurConf.dailyMode === 'DAILY_INTERVAL'"
                  class="pa-0"
                >
                  Recurr Every <input
                    v-model="recurConf.dailyDays"
                    class="ft-simple-number-input"
                    min="1"
                    type="number"
                  > Days
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="1">
              <v-card
                flat
                class="pt-3"
              >
                <v-card-text
                  v-if="recurConf.dailyMode === 'DAILY_INTERVAL'"
                  class="pa-0"
                >
                  Recurr Every <input
                    v-model="recurConf.weeklyWeeks"
                    class="ft-simple-number-input"
                    min="1"
                    type="number"
                  > Weeks
                </v-card-text>
                <days-switch
                  v-model="recurConf.weeklyDays"
                  label="On"
                  :disabled="isFormDisabled"
                  :get-path-errors="getPathErrors"
                  :clear-path-errors="clearPathErrors"
                />
              </v-card>
            </v-tab-item>
            <v-tab-item :key="2">
              <v-card
                flat
                class="pt-3"
              >
                <v-autocomplete
                  v-model="recurConf.monthlyMode"
                  label="Monthly Mode"
                  :items="recurMonthlyModes"
                />
                <v-card-text
                  v-if="recurConf.monthlyMode === 'DAY_OF_MONTH'"
                  class="pa-0"
                >
                  Recurr Every <input
                    v-model="recurConf.monthlyDayOfMonth"
                    class="ft-simple-number-input"
                    type="number"
                    min="1"
                    max="31"
                  > Day of Every
                  <input
                    v-model="recurConf.monthlyMonths"
                    class="ft-simple-number-input"
                    type="number"
                    min="1"
                  > Months
                </v-card-text>
                <v-card-text
                  v-else-if="recurConf.monthlyMode === 'DAY_OF_WEEK'"
                  class="pa-0"
                >
                  Recurr Every
                  <select
                    v-model="recurConf.monthlyDayOfWeekInterval"
                    class="ft-simple-select"
                  >
                    <option
                      v-for="(o, i2) in recurDayOfWeekIntervals"
                      :key="i2"
                      :value="o.value"
                    >
                      {{ o.text }}
                    </option>
                  </select>
                  <select
                    v-model="recurConf.monthlyDayOfWeek"
                    class="ft-simple-select"
                  >
                    <option
                      v-for="(o, i2) in dayOfWeekList"
                      :key="i2"
                      :value="o.value"
                    >
                      {{ o.text }}
                    </option>
                  </select>
                  of Every
                  <input
                    v-model="recurConf.monthlyMonths"
                    class="ft-simple-number-input"
                    type="number"
                    min="1"
                  > Months
                </v-card-text>
              </v-card>
            </v-tab-item>
            <!--
              <v-tab-item :key="3">
                <v-card flat class="pt-3">
                  <v-autocomplete
                    label="Yearly Mode"
                    v-model="recurConf.yearlyMode"
                    :items="recurMonthlyModes"></v-autocomplete>
                  <v-card-text class="pa-0" v-if="recurConf.yearlyMode === 'DAY_OF_MONTH'">
                    Recurr Every <input class="ft-simple-number-input" type="number" v-model="recurConf.yearlyYears" min="1"/> Years
                    on <select class="ft-simple-select" v-model="recurConf.yearlyMonth"><option v-for="(o, i2) in monthList" :value="o.value">{{o.text}}</option></select>
                    <input class="ft-simple-number-input" type="number" v-model="recurConf.yearlyDayOfMonth" min="1" max="31"/>
                  </v-card-text>
                  <v-card-text class="pa-0" v-else-if="recurConf.yearlyMode === 'DAY_OF_WEEK'">
                    Recurr Every <input class="ft-simple-number-input" type="number" v-model="recurConf.yearlyYears" min="1"/> Years
                    on the <select class="ft-simple-select" v-model="recurConf.yearlyDayOfWeekInterval"><option v-for="(o, i2) in recurDayOfWeekIntervals" :value="o.value">{{o.text}}</option></select>
                    <select class="ft-simple-select" v-model="recurConf.yearlyDayOfWeek"><option v-for="(o, i2) in dayOfWeekList" :value="o.value">{{o.text}}</option></select>
                    of <select class="ft-simple-select" v-model="recurConf.yearlyMonth"><option v-for="(o, i2) in monthList" :value="o.value">{{o.text}}</option></select>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              -->
            <v-tab-item :key="4">
              <v-card
                ref="singleDatePickerContainer"
                v-resize="singleDatePickerResize"
                flat
                class="pt-3"
              >
                <v-date-picker
                  v-model="recurConf.singleDate"
                  :min="minDate"
                  :max="maxDate"
                  :landscape="landscapeSinglePicker"
                />
              </v-card>
            </v-tab-item>
          </v-tabs>

          <template v-if="selectedRecurType !== 'SINGLE'">
            <v-layout
              v-if="!itemData.eventOnly"
              wrap
              class="ft-negmx-3"
            >
              <v-flex class="xs12 sm6 md6 px-3">
                <date-picker
                  v-model.trim="recurConf.startDate"
                  label="From"
                  :disabled="isFormDisabled"
                  :min="minDate"
                  :max="maxDate"
                />
              </v-flex>
              <v-flex class="xs12 sm6 md6 px-3">
                <date-picker
                  v-model.trim="recurConf.endDate"
                  label="To"
                  :disabled="isFormDisabled"
                  :min="minDate"
                  :max="maxDate"
                />
              </v-flex>
            </v-layout>

            <v-text-field
              v-model.trim="maxRecur"
              label="Maximum Recurrences to Create"
              type="number"
              min="1"
              max="1000"
            />
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            text
            @click="closeEventCloneDialog"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="createEventsCheck"
          >
            Create Event{{ selectedRecurType !== 'SINGLE' ? 's' : '' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- CONFIRM ADDITION DIALOG -->
    <v-dialog
      v-model="showConfirmAdditionDialog"
      :max-width="350"
      scrollable
    >
      <v-card>
        <v-card-title>
          <div class="headline">
            Adding Events to Group
          </div>
        </v-card-title>
        <v-divider />
        <v-card-text v-if="dryRunData.added">
          You are about to add {{ dryRunData.added }} new events.  Are you sure?
        </v-card-text>
        <v-card-text v-else-if="!dryRunData.skipped">
          Selected settings will not create any events.  Please check and try again.
        </v-card-text>

        <v-card-text v-if="dryRunData.skipped">
          Creation of {{ dryRunData.skipped }} events skipped because events with the same date and start time already exist.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :color="dryRunData.added ? 'error' : 'primary'"
            text
            @click="closeCreateEventsPrompt"
          >
            <span v-if="dryRunData.added">No</span><span v-else>Ok</span>
          </v-btn>
          <v-btn
            v-if="dryRunData.added"
            color="primary"
            text
            @click="runCreateEvents"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- START OF FORM FIELDS -->

    <v-layout wrap>
      <v-flex class="xs12 sm6 md6 px-3">
        <v-text-field
          v-model.trim="itemData.name"
          :label="type + ' Name'"
          :rules="rules().required('Name')"
          :error-messages="getPathErrors(jsonPath, 'name')"
          :disabled="isFormDisabled"
          required
          @input="clearPathErrors(jsonPath, 'name')"
        />
      </v-flex>
      <v-flex class="xs12 sm6 md6 px-3">
        <v-textarea
          v-model.trim="itemData.notes"
          label="Comments"
          :rows="1"
          auto-grow
          :error-messages="getPathErrors(jsonPath, 'notes')"
          :disabled="isFormDisabled"
          @input="clearPathErrors(jsonPath, 'notes')"
        />
      </v-flex>
    </v-layout>

    <v-flex class="px-3">
      <detail-editor-table
        v-model="itemData.events"
        type="Event"
        :json-path="buildJsonPath('events')"
        :get-path-errors="getPathErrors"
        :clear-path-errors="clearPathErrors"
        :move-path-errors="movePathErrors"
        :disabled="isFormDisabled"
        disable-add
        row-buttons
        hide-default-footer
        :set-row-class="setEventRowClass"
        :item-default="eventTemplate"
        :row-select-action="rowSelected"
        delete-confirm-text="Remove"
        :item-name="(item) => {
          return item.name + ' for ' + item.date + ' at ' + $ftPrettyTime(item.startTime)
        }"
        :headers="[
          headerEditor({label: 'Name', field: 'name', editor: {type: 'slot'}}),
          headerEditor({label: 'Date', field: 'date', editor: {type: 'slot'}}),
          headerEditor({label: 'Start Time', field: 'startTime', editor: {type: 'slot'}})
        ]"
        @error="addError"
        @add="resetItemFieldErrorLookup"
      >
        <template
          slot="name"
          slot-scope="props"
        >
          <div>{{ props.value }}</div>
        </template>
        <template
          slot="date"
          slot-scope="props"
        >
          <div>{{ props.value }}</div>
        </template>
        <template
          slot="startTime"
          slot-scope="props"
        >
          <div>{{ $ftPrettyTime(props.value) }}</div>
        </template>
        <template
          slot="row-buttons"
          slot-scope="props"
        >
          <v-btn
            v-if="props.item.id"
            icon
            :disabled="isFormDisabled"
            @click="editEvent(props.item)"
          >
            <v-icon color="grey darken-1">
              mdi-pencil
            </v-icon>
          </v-btn>
          <v-btn
            icon
            :disabled="isFormDisabled"
            @click="setBaseEvent(props.item)"
          >
            <v-icon color="grey darken-1">
              mdi-content-duplicate
            </v-icon>
          </v-btn>
        </template>
      </detail-editor-table>
    </v-flex>
    <!-- END OF FORM FIELDS -->
  </item-editor-dialog>
</template>

<script>
import {values, helpers, itemEdit, withChildren} from '@/ft-vue-core'
import {cloner} from './util/values'
import moment from 'moment'

const {daysProper, daysLower, monthsProper} = values
const {deepClone} = helpers

const DAILY = 'DAILY'
const WEEKLY = 'WEEKLY'
const MONTHLY = 'MONTHLY'
const YEARLY = 'YEARLY'
const SINGLE = 'SINGLE'

const EVERY_WEEKDAY = 'EVERY_WEEKDAY'
const DAILY_INTERVAL = 'DAILY_INTERVAL'

const DAY_OF_MONTH = 'DAY_OF_MONTH'
const DAY_OF_WEEK = 'DAY_OF_WEEK'

var itemDefault = {
  name: '',
  notes: '',
  id: null,
  events: [],
  recordLockExpiration: null
}

export default {
  name: 'EventGroupsItem',
  components: {
  },
  mixins: [itemEdit, withChildren],
  props: {
    baseEventId: [Number, String, Object]
  },
  data: function () {
    return {
      type: 'Recurrence Group',
      types: 'Recurrence Group',
      apiRecordCommand: 'diningEventGroup',
      itemDefault: itemDefault,
      baseEvents: [],
      selectedHash: null,
      disableAdd: true,
      eventTemplate: {},
      landscapeSinglePicker: false,
      maxRecur: 10,
      recurConf: {
        selectedRecurTabIndex: 0,
        startDate: null,
        endDate: null,
        singleDate: null,
        dailyMode: DAILY_INTERVAL,
        dailyDays: 1,
        weeklyWeeks: 1,
        weeklyDays: {
          sunday: true,
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false
        },
        monthlyMode: DAY_OF_MONTH,
        monthlyDayOfMonth: 1,
        monthlyDayOfWeek: 1,
        monthlyDayOfWeekInterval: 1,
        monthlyMonths: 1,
        yearlyMode: DAY_OF_MONTH,
        yearlyMonth: 1,
        yearlyDayOfMonth: 1,
        yearlyDayOfWeek: 1,
        yearlyDayOfWeekInterval: 1,
        yearlyYears: 1
      },
      recurDailyModes: [
        {value: DAILY_INTERVAL, text: 'Interval'},
        {value: EVERY_WEEKDAY, text: 'Every Weekday'}
      ],
      recurMonthlyModes: [
        {value: DAY_OF_MONTH, text: 'Day of Month'},
        {value: DAY_OF_WEEK, text: 'Day of Week'}
      ],
      recurDayOfWeekIntervals: [
        {value: 1, text: 'First'},
        {value: 2, text: 'Second'},
        {value: 3, text: 'Third'},
        {value: 4, text: 'Fourth'}
      ],
      recurTabs: [
        {value: DAILY, text: 'Daily'},
        {value: WEEKLY, text: 'Weekly'},
        {value: MONTHLY, text: 'Monthly'},
        // {value: YEARLY, text: 'Yearly'},
        {value: SINGLE, text: 'Single'}
      ],
      eventCloner: cloner,
      dryRunData: {added: 0, skipped: 0},
      showEventCloneDialog: false,
      showConfirmAdditionDialog: false
    }
  },
  computed: {
    forceReadOnly () {
      return !this.$ftAccess.manageEvents
    },
    getDisabledInverted () {
      return !this.itemData.disabled
    },
    minDate () {
      return this.$ftAPI().clubMoment().format('YYYY-MM-DD')
    },
    maxDate () {
      return this.$ftAPI().clubMoment().add(1, 'years').format('YYYY-MM-DD')
    },
    baseEvent () {
      return this.baseEvents[0]
    },
    selectedRecurTab () {
      return this.recurTabs[this.recurConf.selectedRecurTabIndex] || {}
    },
    selectedRecurType () {
      return this.selectedRecurTab.value
    },
    dayOfWeekList () {
      return daysProper.map((v, i) => {
        return {text: v, value: i}
      })
    },
    monthList () {
      return monthsProper.map((v, i) => {
        return {text: v, value: i}
      })
    }
  },
  watch: {
    selectedRecurTab (val) {
      this.singleDatePickerResize()
    },
    recurConf: {
      handler: function (val) {
        this.updateMaxRecur()
      },
      deep: true
    }
  },
  methods: {
    editEvent (item) {
      this.promptReleaseLock(() => {
        this.$router.push({path: '/events/all', query: {id: item.id}})
      })
    },
    isLikeBaseEvent (item) {
      return this.baseEvent && (this.baseEvent.id === item.id || this.baseEvent.fuzzyHash === item.fuzzyHash) || this.selectedHash === item.fuzzyHash
    },
    setEventRowClass (item, rowClass) {
      const isLikeBaseEvent = this.isLikeBaseEvent(item)
      rowClass['ft-new-detail'] = !item.id
      rowClass['ft-hash-' + item.fuzzyHash] = true
      rowClass['ft-selected-detail'] = isLikeBaseEvent && item.id
      if (item.cancelled) {
        rowClass['ft-cancelled-event-row'] = true
      }
    },
    rowSelected (item) {
      this.setSelectedHash(item)
    },
    setBaseEvent (item) {
      this.baseEvents = [item]
      this.setSelectedHash(item)
      if (item) this.showEventCloneDialog = true
    },
    setSelectedHash (item) {
      if (item && this.baseEvents[0] && item.fuzzyHash !== this.baseEvents[0].fuzzyHash) this.baseEvents = []
      if (item) {
        this.selectedHash = item.fuzzyHash
      } else {
        this.selectedHash = null
      }
    },
    createEventsCheck () {
      this.dryRunData = this.createEvents(true)
      this.showConfirmAdditionDialog = true
    },
    closeCreateEventsPrompt () {
      this.showConfirmAdditionDialog = false
    },
    closeEventCloneDialog () {
      this.showEventCloneDialog = false
    },
    runCreateEvents () {
      this.closeCreateEventsPrompt()
      this.closeEventCloneDialog()
      this.createEvents()
    },
    updateMaxRecur () {
      const values = this.createEvents(true, true)
      if (values.total) {
        this.maxRecur = values.total
      } else {
        this.maxRecur = null
      }
    },
    createEvents (dryRun, skipMaxRecurr) {
      const singleDate = moment(this.recurConf.singleDate)
      const startDate = moment(this.recurConf.startDate)
      const endDate = moment(this.recurConf.endDate)
      const maxRecur = this.maxRecur || 0
      var events = []

      const __addNewEvent = (date) => {
        const event = this.cleanClone(deepClone(this.baseEvent), cloner)
        event.date = date.format('YYYY-MM-DD')
        events.push(event)
      }

      switch (this.selectedRecurType) {
      case SINGLE:
        if (!singleDate.isValid()) return {added: 0, skipped: 0, error: 'Date not selected'}
        __addNewEvent(singleDate)
        break

      case DAILY: {
        if (!startDate.isValid() || !endDate.isValid()) return {added: 0, skipped: 0, error: 'Dates not selected'}
        if (endDate.isBefore(startDate)) return {added: 0, skipped: 0, error: 'Invalid dates'}
        const dailyMode = this.recurConf.dailyMode
        const dailyDays = this.recurConf.dailyDays
        const useDailyInterval = dailyMode === DAILY_INTERVAL
        if (useDailyInterval && !dailyDays) return {added: 0, skipped: 0, error: 'Interval not selected'}
        for (let date = startDate.clone(); date.isSameOrBefore(endDate); date.add(useDailyInterval ? dailyDays : 1, 'days')) {
          if (!useDailyInterval) {
            // Must be for week days
            if (date.isoWeekday() > 5) continue // Not a weekday
          }
          __addNewEvent(date)
        }
        break
      }

      case WEEKLY: {
        if (!startDate.isValid() || !endDate.isValid()) return {added: 0, skipped: 0, error: 'Dates not selected'}
        if (endDate.isBefore(startDate)) return {added: 0, skipped: 0, error: 'Invalid dates'}
        const weeklyWeeks = this.recurConf.weeklyWeeks
        if (!weeklyWeeks) return {added: 0, skipped: 0, error: 'Weeks not selected'}
        for (let date = startDate.clone(); date.isSameOrBefore(endDate); date.add(weeklyWeeks, 'weeks')) {
          for (let i = date.day(); i < 7; i++) {
            if (this.getDayValByDay(i)) {
              __addNewEvent(date)
            }
            if (i < 6) {
              date.add(1, 'days') // Advance to next day
            } else {
              date.day(0) // Reset to first day of the week, so add week loop works
            }
          }
        }
        break
      }

      case MONTHLY: {
        if (!startDate.isValid() || !endDate.isValid()) return {added: 0, skipped: 0, error: 'Dates not selected'}
        if (endDate.isBefore(startDate)) return {added: 0, skipped: 0, error: 'Invalid dates'}
        const monthlyMonths = this.recurConf.monthlyMonths
        const monthlyMode = this.recurConf.monthlyMode
        const monthlyDayOfMonth = parseInt(this.recurConf.monthlyDayOfMonth, 10)
        const monthlyDayOfWeek = parseInt(this.recurConf.monthlyDayOfWeek, 10)
        const monthlyDayOfWeekInterval = this.recurConf.monthlyDayOfWeekInterval
        if (!monthlyMonths) return {added: 0, skipped: 0, error: 'Months not selected'}
        for (let date = startDate.clone(); date.isSameOrBefore(endDate); date.add(monthlyMonths, 'months')) {
          const daysInMonth = date.daysInMonth()
          for (let i = date.date(); i <= daysInMonth; i++) {
            if (monthlyMode === DAY_OF_MONTH) {
              // By day of month
              if (i === monthlyDayOfMonth) {
                __addNewEvent(date)
                date.date(1) // Reset to first day of the month, so add month loop works
                break // Done with this month
              }
            } else {
              // Must be by day of week
              if (Math.ceil(i / 7) === monthlyDayOfWeekInterval && date.day() === monthlyDayOfWeek) {
                // We're in the correct week & day
                __addNewEvent(date)
                date.date(1) // Reset to first day of the month, so add month loop works
                break // Done with this month
              }
            }
            if (i < daysInMonth) {
              date.add(1, 'days') // Advance to next day
            } else {
              date.date(1) // Reset to first day of the month, so add month loop works
            }
          }
        }
        break
      }

      case YEARLY: {
        if (!startDate.isValid() || !endDate.isValid()) return {added: 0, skipped: 0, error: 'Dates not selected'}
        if (endDate.isBefore(startDate)) return {added: 0, skipped: 0, error: 'Invalid dates'}
        const yearlyYears = this.recurConf.yearlyYears
        const yearlyMode = this.recurConf.yearlyMode
        const yearlyDayOfMonth = parseInt(this.recurConf.yearlyDayOfMonth, 10)
        const yearlyDayOfWeek = parseInt(this.recurConf.yearlyDayOfWeek, 10)
        const yearlyDayOfWeekInterval = this.recurConf.yearlyDayOfWeekInterval
        const yearlyMonth = this.recurConf.yearlyMonth
        if (!yearlyYears) return {added: 0, skipped: 0, error: 'Years not selected'}
        for (let date = startDate.clone(); date.isSameOrBefore(endDate); date.add(yearlyYears, 'years')) {
          const daysInYear = moment([date.year(), 11, 31]).diff(moment([date.year()]), 'days')
          for (let i = date.dayOfYear(); i <= daysInYear; i++) {
            if (yearlyMode === DAY_OF_MONTH) {
              // By day of month
              if (date.month() === yearlyMonth && date.date() === yearlyDayOfMonth) {
                __addNewEvent(date)
                date.dayOfYear(1) // Reset to first day of the year, so add year loop works
                break // Done with this month
              }
            } else {
              // Must be by day of week
              if (date.month() === yearlyMonth &&
                  Math.ceil(date.date() / 7) === yearlyDayOfWeekInterval &&
                  date.day() === yearlyDayOfWeek) {
                // We're in the correct week & day
                __addNewEvent(date)
                date.dayOfYear(1) // Reset to first day of the year, so add year loop works
                break // Done with this month
              }
            }
            if (i < daysInYear) {
              date.add(1, 'days') // Advance to next day
            } else {
              date.dayOfYear(1) // Reset to first day of the year, so add year loop works
            }
          }
        }
        break
      }

      default:
        return {added: 0, skipped: 0, error: 'Invalid Recurr Type Selected'}
      }

      if (!skipMaxRecurr && events.length > maxRecur) events = events.slice(0, maxRecur)

      return this.addEvents(events, dryRun)
    },
    getDayValByDay (day) {
      return this.recurConf.weeklyDays[daysLower[day]]
    },
    addEvents (events, dryRun) {
      // Filter out any events for dates/times we already have
      // TODO: Deal with locations???
      const existingEvents = this.itemData.events
      const newEvents = events.filter(event => !existingEvents.find(e => e.date === event.date && e.startTime === event.startTime))
      const skippedEvents = events.filter(event => existingEvents.find(e => e.date === event.date && e.startTime === event.startTime))
      if (!dryRun) {
        existingEvents.push(...newEvents)
        // Sort by date/time
        this.itemData.events = existingEvents.sort((a, b) => {
          const ac = a.date + a.startTime
          const bc = b.date + b.startTime
          return ac > bc ? 1 : ac < bc ? -1 : 0
        })
        this.resetFieldErrorLookup(this.itemData)
      }
      return {total: events.length, added: newEvents.length, skipped: skippedEvents.length, success: newEvents.length > 0, newEvents: newEvents, skipedEvents: skippedEvents}
    },
    singleDatePickerResize () {
      setTimeout(() => {
        const singleDatePickerContainer = this.$refs.singleDatePickerContainer
        this.landscapeSinglePicker = singleDatePickerContainer && singleDatePickerContainer.$el.offsetWidth > 420
      }, 0)
    },
    itemResourceCommands () {
      return [
        {
          command: 'diningEvent',
          load: this.baseEvents,
          loading: this.isLoading,
          params: {
            children: true,
            include_fuzzy_hash: true,
            filter: [{field: 'id', operator: 'EQUAL', values: [this.baseEventId || 0]}]
          }
        }
      ]
    },
    withChildrenItemCommandFilter (command) {
      this.addCommandParam(command, 'include_fuzzy_hash', true)
      this.addCommandParam(command, 'order_by', ['diningEvent.date:DESC', 'diningEvent.startTime:DESC'])
      return command
    },
    afterLoad (r) {
      this.addEvents(this.baseEvents)
      if (this.baseEvents && this.baseEvents.length) {
        setTimeout(() => {this.setBaseEvent(this.baseEvents[0])}, 0)
      }
    }
  }
}
</script>
<style>
  input.ft-simple-number-input {
    border-bottom: 1px solid;
    width: 50px;
  }
  select.ft-simple-select {
    border-bottom: 1px solid;
    padding-bottom: 1px;
    appearance: menulist;
  }
  .ft-selected-detail td {
    background-color: rgba(128, 255, 0, 0.219);
  }
  .ft-new-detail td {
    background-color: rgba(255, 255, 0, 0.13);
  }
  .ft-cancelled-event-row {
    text-decoration: line-through;
  }
</style>
